import { FDCNotificationEvent, alphabeticalSort } from '@cims-online/shared'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { Space } from 'antd'
import { useFDCNotificationsContext } from '../../FDCNotificationsContext'
import { HelpMessage } from 'utils/constants'
import RecipientsTags from 'components/CIMSTags/common/RecipientsTags'
import CIMSCollapse from 'components/CIMSCollapse'
import TwoDimensionalCollapse from './components/TwoDimensionalCollapse'
import GroupFallback from '../GroupFallback'
import NotConfigured from './components/NotConfigured'
import CIMSSection from 'components/CIMSSection'

const ViewFDCNotificationEvent: React.FC = () => {
  const help = HelpMessage.FieldDesignChanges.Notifications
  const { event } = useCIMSNotificationsPanelContext()
  const { data } = useFDCNotificationsContext()
  const { every, byConcurrenceLevel } =
    useFDCNotificationsContext().recipients(event)
  let children
  if (event === FDCNotificationEvent.GroupApproved)
    children = <TwoDimensionalCollapse group="Approval Group" />
  else if (event === FDCNotificationEvent.AnyLevelConcurred)
    children = <TwoDimensionalCollapse group="Concurrence Group" />
  else children = null
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <CIMSSection
        help={HelpMessage.Notifications.Every(event, 'Field Design Change')}
        title={`Every ${event.name} Event`}
      >
        <RecipientsTags
          noRecipientsContent={<NotConfigured type="Every" />}
          recipients={every}
        />
      </CIMSSection>

      <CIMSSection
        help={help.ByConcurrenceLevel(event)}
        title="Concurrence Levels"
      >
        <CIMSCollapse
          noPanelsContent={<GroupFallback group="Concurrence Levels" />}
          panels={data?.fdcConcurrenceLevels
            ?.sort(alphabeticalSort('name'))
            .map(({ id: key, name, description }) => {
              const recipients = byConcurrenceLevel.find(
                ({ concurrenceLevel }) => concurrenceLevel.id === key
              )?.recipients
              return {
                key,
                header: {
                  type: 'described',
                  name,
                  description,
                },
                children: (
                  <RecipientsTags
                    noRecipientsContent={
                      <NotConfigured type="Concurrence Level" name={name} />
                    }
                    recipients={recipients}
                  />
                ),
              }
            })}
        />
      </CIMSSection>
      {children}
    </Space>
  )
}

export default ViewFDCNotificationEvent
